import React from 'react';
import logo from './logo.svg';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import LoginPage from './components/LoginPage/LoginPage';
import CreditUnionSearch from './components/CreditUnionSearch/CreditUnionSearch';
import PremiumReportList from './components/PremiumReportList/PremiumReportList';

function App() {
  return (
    <Router>
    <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route path="/CreditUnionSearch" element={<CreditUnionSearch />} />
      <Route path="/PremiumReportList" element={<PremiumReportList userName={'tri doe'} creditUnionNumber={'012-3456-78'} />} />
      
    </Routes>
  </Router>
 
  );
}

export default App;
